var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg046Expand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.142,162.858L68.285,40H147c11.046,0,20-8.954,20-20s-8.954-20-20-20H60C26.916,0,0,26.916,0,60v87 c0,11.046,8.954,20,20,20s20-8.954,20-20V68.285l122.858,122.858C166.763,195.048,171.881,197,177,197s10.237-1.952,14.142-5.857 C198.953,183.332,198.953,170.668,191.142,162.858z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.142,320.858c-7.811-7.81-20.474-7.811-28.284-0.001L40,443.715V365c0-11.046-8.954-20-20-20s-20,8.954-20,20v87 c0,33.084,26.916,60,60,60h87c11.046,0,20-8.954,20-20c0-11.046-8.954-20-20-20H68.285l122.857-122.857 C198.953,341.332,198.953,328.668,191.142,320.858z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492,345c-11.046,0-20,8.954-20,20v78.715L349.142,320.857c-7.811-7.811-20.474-7.811-28.284,0 c-7.81,7.811-7.811,20.475,0,28.285L443.715,472H365c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h87 c33.084,0,60-26.916,60-60v-87C512,353.954,503.046,345,492,345z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452,0h-87c-11.046,0-20,8.954-20,20s8.954,20,20,20h78.715L320.858,162.857c-7.811,7.811-7.811,20.475,0,28.285 C324.763,195.048,329.881,197,335,197c5.119,0,10.237-1.952,14.142-5.857L472,68.285V147c0,11.046,8.954,20,20,20 c11.046,0,20-8.954,20-20V60C512,26.916,485.084,0,452,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg046Expand);
export default __webpack_public_path__ + "static/media/046-expand.da3fbb3f43560a475f91de42190cda4b.svg";
export { ForwardRef as ReactComponent };